{
  "title": "Catapult",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S",
  "duration": "Instantaneous",
  "description": [
    "Choose one object weighing 1 to 5 pounds within range that isn’t being worn or carried. The object flies in a straight line up to 90 feet in a direction you choose before falling to the ground, stopping early if it impacts against a solid surface. If the object would strike a creature, that creature must make a Dexterity saving throw. On a failed save, the object strikes the target and stops moving. When the object strikes something, the object and what it strikes each take 3d8 bludgeoning damage.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the maximum weight of objects that you can target with this spell increases by 5 pounds, and the damage increases by 1d8, for each slot level above 1st."
  ],
  "spellLists": ["artificer", "sorcerer", "wizard"]
}
